// home page javascript

const hamburger = document.querySelector(".header_hamburger_image")
const headerbtns = document.querySelector(".header_btns")
const overflow = document.querySelector(".overflow")
const hamburgerclosebtn  = document.querySelector(".header_hamburger_closebtn")
const body = document.querySelector(".main_header")



hamburger.addEventListener("click", () => {
  headerbtns.classList.toggle("show")
  overflow.classList.toggle("show")
})

var swiper = new Swiper(".mySwiper", {
  effect: "coverflow",
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: "auto",
  spaceBetween: 30,
  loop: true,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 2,
    slideShadows: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,  
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

// product page javascript


const tabs = document.querySelectorAll(".tab_btn")
const all_contents = document.querySelectorAll(".content")

tabs.forEach((tab, index) => {
    tab.addEventListener('click', (e) => {
        tabs.forEach(tab=>{tab.classList.remove('active')})
       tab.classList.add('active')

       var line = document.querySelector('.line')
       line.style.width = e.target.offsetWidth + "px"
       line.style.left = e.target.offsetLeft + "px"

       all_contents.forEach(content=>{content.classList.remove('active')})
       all_contents[index].classList.add('active')
    })
})


const product_title = document.querySelectorAll(".product_mob_accordian_1")

product_title.forEach((acc) => {
    acc.addEventListener("click", (e) => {
        acc.classList.toggle("active")  

        var mob_line = document.querySelector('.mob_line')
        mob_line.style.width = e.target.offsetWidth + "px"
        
    })
})  
